import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * LoginPage - Redirects to Client Login
 * The old OpenClaw login page has been replaced.
 * Admin and client login both use /client/login
 */
export default function LoginPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to the Alaska AI Services client login
    navigate('/client/login', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center">
      <p className="text-slate-400">Redirecting to login...</p>
    </div>
  );
}
